import PropTypes from 'prop-types';

import Card from '#globalComponents/Card/Card';

import CollectionItemActions, { getRenameAction } from './CollectionItemActions';
import { CollectionItemDate, CollectionItemStats, CollectionItemTags } from './CollectionItemDetails';
import { collectionItemShape } from './collectionItemShape';
import CollectionItemTitle from './CollectionItemTitle';
import { openableProps } from './openableProps';

const CollectionRow = ({ item, isRenaming, onRenameStart, onRenameEnd }) => (
	<Card
		{...openableProps(item.onOpen, isRenaming)}
		className="grid cursor-pointer grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)_auto] items-center gap-6 px-6 py-5 transition-colors hover:border-primary-200 hover:bg-primary-100"
	>
		<div className="min-w-0">
			<CollectionItemTitle
				title={item.title}
				isRenaming={isRenaming}
				onRename={item.onRename}
				onRenameEnd={onRenameEnd}
			/>
			<CollectionItemStats stats={item.stats} />
		</div>
		<CollectionItemTags tags={item.tags} />
		<CollectionItemDate date={item.date} className="text-center" />
		<CollectionItemActions actions={[getRenameAction(item, onRenameStart), ...(item.actions ?? [])]} />
	</Card>
);

CollectionRow.propTypes = {
	item: collectionItemShape.isRequired,
	isRenaming: PropTypes.bool.isRequired,
	onRenameStart: PropTypes.func.isRequired,
	onRenameEnd: PropTypes.func.isRequired,
};

export default CollectionRow;
